import { auth } from '@/plugins/firebase'
import { signInWithEmailAndPassword } from 'firebase/auth'
import Service from '@/helpers/service'
import { version } from '../../../package.json'

export default {
  namespaced: true,
  state: {
    mail: null,
    client: null,
    serviceId: null,
    dayType: null,
    daysOffDifference: 0,
    pastServices: [],
    todayServices: [],
    futureServices: [],
    uid: null,
    chatSession: null,
    tokenFCM: null,
    device: null
  },
  mutations: {
    setSessionAuthChat(state, params) {
      state.uid = params.uid
      state.chatSession = params.chatSession
    },
    setSessionInfo(state, params) {
      state.mail = params.mail
      state.client = params.client
      state.serviceId = params.serviceId
      state.dayType = params.dayType
    },
    setDeviceToken(state, params) {
      if (params.token) {
        state.tokenFCM = params.token
      }

      if (params.device) {
        state.device = params.device
      }
    },
    setPastServices(state, services) {
      state.pastServices = services.map((service) => {
        const grade = service.grade ? service.grade : 0
        const status = service.status ? service.status : 3

        const nService = new Service(
          service.item_id,
          service.confirmation,
          service.location,
          service.destination,
          service.destinationLatitude,
          service.destinationLongitude,
          service.van,
          service.locationLatitude,
          service.locationLongitude,
          0.0,
          service.driver,
          service.type,
          grade,
          service.date,
          status,
          '',
          '',
          0
        )

        nService.pax = service.pax
        nService.w3cDate = service.w3cDate
        nService.time = service.time

        return nService
      })
    },
    setTodayServices(state, services) {
      state.todayServices = services.map((service) => {
        const status = service.status ? service.status : 2
        const time =
          service.SERVICE_TYPE == 'EX'
            ? service.RSTO_SERVICE_TIME
            : service.RSTR_SERVICE_TIME

        const nService = new Service(
          service.item_id,
          service.confirmation,
          service.location,
          service.destination,
          0.0,
          0.0,
          '',
          0.0,
          0.0,
          0.0,
          '',
          service.SERVICE_TYPE,
          0,
          'Today',
          status,
          service.EditBase,
          service.EditParams,
          0
        )

        nService.arrivalTime = service.arrival_time
        nService.balance = service.balance
        nService.time = time
        nService.w3cDate = service.w3cDate

        return nService
      })
    },
    setFutureServices(state, services) {
      state.futureServices = services.map((service) => {
        const status = service.status ? service.status : 2

        const nService = new Service(
          service.item_id,
          service.confirmation,
          service.location,
          service.destination,
          0.0,
          0.0,
          '',
          0.0,
          0.0,
          0.0,
          '',
          service.type,
          0,
          service.date,
          status,
          service.EditBase,
          service.EditParams,
          0
        )

        nService.pax = service.pax
        nService.balance = service.balance
        nService.time = service.time
        nService.w3cDate = service.w3cDate

        return nService
      })
    },
    unsetSessionInfo(state) {
      state.client = null
      state.dayType = null
      state.daysOffDifference = 0
      state.pastServices = []
      state.todayServices = []
      state.futureServices = []
      auth.signOut()
    }
  },
  getters: {
    hasSession(state) {
      return state && state.mail && state.client && state.serviceId
    },
    homeService(state) {
      if (state.dayType) {
        if (state.dayType === 'serviceDay') {
          if (state.todayServices.length > 0) {
            // handle today services ***
            return state.todayServices[0]
          } else if (state.pastServices.length > 0) {
            return state.pastServices[0]
          }
        } else if (state.dayType === 'before') {
          if (
            state.daysOffDifference === 1 &&
            state.futureServices.length > 0
          ) {
            return state.futureServices[0]
          } else if (state.pastServices.length > 0) {
            return state.pastServices[0]
          } else if (state.futureServices.length > 0) {
            return state.futureServices[0]
          }
        } else if (state.dayType === 'after') {
          if (state.pastServices.length > 0) {
            return state.pastServices[0]
          }
        }
      }

      return null
    },
    pastLength(state) {
      return state.pastServices.length
    },
    todayLength(state) {
      return state.todayServices.length
    },
    futureLength(state) {
      return state.futureServices.length
    }
  },
  actions: {
    setSession({ commit }, params) {
      commit('setSessionInfo', params)
      commit('setPastServices', params.pastServices)
      commit('setTodayServices', params.todayServices)
      commit('setFutureServices', params.futureServices)
    },
    unsetSession({ commit }) {
      commit('unsetSessionInfo')
    },
    async handleRegister({ dispatch, commit, state }, params) {
      const result = await dispatch(
        'request',
        {
          baseUrl: process.env.VUE_APP_FUNCTIONS_URL,
          url: 'client_api/register',
          method: 'post',
          body: {
            email: params.email,
            password: params.service,
            epReservation: params.service,
            tokenFCM: state.tokenFCM,
            name: params.client,
            uid: null,
            chat_session: null
          }
        },
        { root: true }
      )

      if (result.status) {
        await commit('setSessionAuthChat', {
          uid: result.data.data.uid,
          chatSession: result.data.data.chat_session
        })

        await signInWithEmailAndPassword(
          auth,
          params.email,
          result.data.data.password
        )
      }
    },
    async handleLogin({ dispatch, commit, rootState }, params) {
      const response = await dispatch(
        'request',
        {
          baseUrl: process.env.VUE_APP_USA_URL,
          url: 'clientsapp/index.php',
          method: 'get',
          body: {
            action: 'login',
            client: params.email,
            itemId: params.service,
            device: params.device,
            version
          }
        },
        { root: true }
      )

      // response 2 es error
      if (response.status && response.data.response < 2) {
        const session = {
          mail: params.email,
          client: response.data.client,
          serviceId: params.service,
          dayType: response.data.dayType,
          pastServices: response.data.past,
          todayServices: response.data.today,
          futureServices: response.data.future
        }

        if (rootState.firebaseMessagingInstance) {
          await commit('setDeviceToken', { token: null, device: 'Android' })
        }

        await dispatch('setSession', session)

        await dispatch('handleRegister', {
          email: params.email,
          service: params.service,
          client: response.data.client
        })
      }

      return response
    },
    // No usado por ahora
    async handleRedirect({ dispatch, commit, state }, user) {
      const token = await user.getIdToken(true)
      if (token && user.uid) {
        const result = await dispatch('request', {
          baseUrl: 'http://192.168.0.170:5000/usatransfersclients/us-central1/',
          url: `client_api/login/${user.uid}/${token}`,
          method: 'get',
          body: {
            action: 'login',
            client: state.email,
            itemId: state.serviceId,
            device: 'test'
          }
        })
        console.log(result)
        if (result.status) {
          await commit('setSessionAuthChat', {
            uid: result.data.uid,
            chatSession: result.data.chat_session
          })
        }
      }
    }
  }
}
